import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import connect from "react-redux/es/connect/connect";
import {ComponentFormatter} from "../../../utils/formatters";
import {activeFilter} from "../../../utils/filters";

class RoyaltyList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        if (filter) {
            if (Array.isArray(filter)) {
                filter.push({field: "licensee", value: this.props.pos.partner.partner_id});
            } else {
                filter = {filters: [filter, {field: "licensee", value: this.props.pos.partner.partner_id}]};
            }
        } else {
            filter = {field: "licensee", value: this.props.pos.partner.partner_id};
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "RoyaltyList"}
                {...props}
                filter={filter}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "licensor.name": {
                        header: 'Jogtulajdonos',
                        width: 4,
                        sortable,
                        filterable
                    },
                    "agent.name": {
                        header: 'Ügynök',
                        width: 3,
                        sortable,
                        filterable
                    },
                    "object_component.displayname": {
                        header: 'Jogcím',
                        width: 3,
                        sortable,
                        filterable
                    },
                    "active": {
                        header: 'Aktív',
                        width: 1,
                        sortable,
                        filterable: activeFilter(),
                        renderer: (value) => value + "" === "1" ? "Aktív" : "Inkatív"
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default RoyaltyList;
